import { useState,useRef, useEffect } from 'react';

export default function FileDnD({
    defaultStyle='',
    dragStyle='',
    onFileDrop,
    onDragOver,
    clickDisabled=false,
    children
}){
    const [isDragOver, setIsDragOver] = useState(false);
    const inputRef = useRef(null);
    const dragCounter = useRef(0);

    useEffect(()=>{
        onDragOver(isDragOver);
    },[isDragOver])

    const handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dragCounter.current++;
        setIsDragOver(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dragCounter.current--;
        if (dragCounter.current === 0) {
          setIsDragOver(false);
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);
        dragCounter.current = 0;

        const files = e.dataTransfer.files;
        if (files && files.length > 0) {
          onFileDrop?.(files);
          e.dataTransfer.clearData();
        }
    };

    const handleClick=()=>{
        if(!clickDisabled){
            inputRef.current?.click();
        }
    }

    const handleFileChange = (e) => {
        const files = e.target.files;
        if (files && files.length > 0) {
          onFileDrop?.(files);
          e.target.value = '';
        }
    };

    return (
        <div
        className={`${defaultStyle} ${isDragOver?dragStyle:''}`}
        onClick={handleClick}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        role='button'
        tabIndex={0}
        onKeyDown={(e)=> { if (e.key === 'Enter' && !clickDisabled) handleClick(); }}
        >
            {children}
            <input
            type='file'
            ref={inputRef}
            onChange={handleFileChange}
            style={{display:'none'}}/>
        </div>
    );
}

